"use strict";

import * as utils from '../util/browser.util';

function init() {
	let qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(window.location.href)}`;

	$('#weChatModal').on('show.bs.modal', function (e) {
		$("img[data-src^='wechat-qr']").attr('src', qrUrl);
		utils.trackEvent('wechat-share', 'share', window.location.href, 1);
	});
}

module.exports = {
	init
};


// WEBPACK FOOTER //
// ./src/scripts/client/plugin/wechat.js